export default __webpack_public_path__ + "static/media/25120406.833fd6cb.jpg";